export default __webpack_public_path__ + "static/media/login.1b32e5ed.png";